export default __webpack_public_path__ + "static/media/sounds/vocab_tqvm_question_instruction_replay.mp3";